<template>
  <div>
    <div
      class="modal fade"
      id="crearTareaManualModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crear Tarea Manual</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                v-bind:class="{
                  'text-danger': current.errors && current.errors.tienda,
                }"
              >
                Tienda Origen
              </label>
              <select
                class="form-control"
                autofocus="autofocus"
                v-model="current.tienda_origen"
                :disabled="current.id != null"    
                         
              >
                <option
                  v-for="(tienda, key) in tiendas"
                  :value="tienda.codigo"
                  :key="key"                 
                >
                  {{ tienda.nombre }}
                </option>
              </select>
              <small
                v-if="current.errors && current.errors.tienda_origen"
                class="form-text text-danger"
                >{{ current.errors.tienda_origen[0] }}</small
              >
            </div>
            <TiendaSelectComponent titulo="Tienda Destino" :current="current" />
            <small v-if="error_tarea" class="form-text text-danger">
              {{ error_tarea }}
            </small>
            <br />
             
            <!-----------------V - SELECT --------------------------->
            <label class="text-">Usuario</label>
            <multiselect
              v-model="current.usuario"
              label="username"              
              :options="usuarios_pickeadores"
              placeholder="Selecciona un usuario"
              aria-label="Selecciona un usuario"
              trackBy="username"
            ></multiselect>
            &nbsp;&nbsp;
            <!------------------FIN DE V - SELECT ------------------->

            <button
              class="btn btn-block btn-primary"
              @click="crearTareaManual()"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import Multiselect, { multiselectMixin } from "vue-multiselect";

export default {
  components: {
    TiendaSelectComponent,
    Multiselect,
  },
  data() {
    return {
      current: {
        tienda_origen: "02",
        tienda: null,
        usuario:"",
        errors: {},
      },
      error_tarea: null,
      usuarios_pickeadores:[],
      usuario_seleccionado:""
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    $("#asignarCarrito").on("shown.bs.modal", function () {
      $("#barra_carrito").trigger("focus");
    });
    this.getUsuariosPickeadores();
  },
  methods: {
    crearTareaManual() {
      let self = this;         
      if(self.current.usuario == null){
        self.current.usuario.id = ""
      }   
      DynamicService.postActionList("wms", "tareas", "crear_tarea_manual", { 
        tienda_origen: self.current.tienda_origen,                         
        tienda_destino: self.current.tienda,
        usuario: self.current.usuario.id
      })
        .then((res) => {
          $("#crearTareaManualModal").modal("hide");          
          self.$router.push({
            name: "wms-tareas-manuales-editar", 
            params: { id: res.data.id },        
          });          
        })
        .catch((err) => {      
          if (err.response.data.tarea) {
            self.error_tarea = err.response.data.tarea;
          }
        });
      
    },
    getUsuariosPickeadores(){    
      let self = this;
      DynamicService.getActionList("wms", "tareas", "get_usuarios_pickeadores","")
       .then((res) => {
        self.current.tienda = []         
        self.usuarios_pickeadores = res.data;                
        })
       .catch((err) => {
          console.log(err);
        });
    },  
  },
};
</script>
